import {SignUpFormContainer} from '../containers/SignUpFormContainer/index'

export const SignUpPage = () => (
    <>
        <SignUpFormContainer/>
    </>
)